import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormElementBase } from '../../adapter/form-element-base.adapter';

@Component({
  selector: 'tekman-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['../../check.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent extends FormElementBase implements ControlValueAccessor {
  @Input() label = '';
  @Input() set disabled(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  constructor() {
    super();
  }
}
